export const applicationErrors = {
  parse: (message) => {
    if (
      message === applicationErrors.un_1.username ||
      message.toLowerCase() === 'banned username'
    ) {
      return applicationErrors.un_1;
    }
    try {
      const match = message.match(/code:\w+/);
      const code = match[0].replace('code:', '');
      return applicationErrors[code];
    } catch (err) {
      return null;
    }
  },
  e_1: { email: 'Email is not confirmed' },
  e_2: { email: 'This email already exist' },
  e_3: { email: 'Wrong email' },
  e_4: { password: 'Wrong password' },
  un_1: { username: 'Username already exists' },
};
